"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizedApolloProvider = void 0;
var client_1 = require("@apollo/client");
var client_2 = require("@apollo/client");
var auth0_react_1 = require("@auth0/auth0-react");
var context_1 = require("@apollo/client/link/context");
var react_1 = __importStar(require("react"));
var loading_layout_1 = require("../elements/loading-layout");
var AuthorizedApolloProvider = function (_a) {
  var children = _a.children;
  var httpLink = new client_1.HttpLink({
    uri: process.env.GRAPHQL_SERVER
  });
  var _b = __read((0, react_1.useState)(''), 2),
    accessToken = _b[0],
    setAccessToken = _b[1];
  var _c = __read((0, react_1.useState)(), 2),
    client = _c[0],
    setClient = _c[1]; // that could be better, actually if you have suggestions they are welcome
  var _d = (0, auth0_react_1.useAuth0)(),
    getAccessTokenSilently = _d.getAccessTokenSilently,
    isLoading = _d.isLoading,
    isAuthenticated = _d.isAuthenticated;
  // get access token
  (0, react_1.useEffect)(function () {
    var getAccessToken = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var token, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 3,, 4]);
              if (!isAuthenticated) return [3 /*break*/, 2];
              return [4 /*yield*/, getAccessTokenSilently()];
            case 1:
              token = _a.sent();
              setAccessToken(token);
              _a.label = 2;
            case 2:
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              console.log(e_1);
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    getAccessToken();
  }, [isAuthenticated]);
  (0, react_1.useEffect)(function () {
    var authLink = (0, context_1.setContext)(function (_, _a) {
      var headers = _a.headers;
      var token = accessToken;
      var baseHeaders = __assign(__assign({}, headers), {
        accesskey: process.env.GRAPHQL_ACCESS_KEY
      });
      if (token) {
        return {
          headers: __assign(__assign({}, baseHeaders), {
            authorization: "Bearer ".concat(token)
          })
        };
      } else {
        return {
          headers: __assign({}, baseHeaders)
        };
      }
    });
    var client = new client_1.ApolloClient({
      link: authLink.concat(httpLink),
      cache: new client_1.InMemoryCache(),
      connectToDevTools: true
    });
    setClient(client);
  }, [accessToken]);
  if (!client) {
    return react_1.default.createElement(loading_layout_1.LoadingLayout, null);
  }
  return react_1.default.createElement(client_2.ApolloProvider, {
    client: client
  }, children);
};
exports.AuthorizedApolloProvider = AuthorizedApolloProvider;
exports.default = exports.AuthorizedApolloProvider;